import FlagUz from '@/assets/icons/flag-z.svg?react';
import FlagRu from '@/assets/icons/flag-ru.svg?react';
import FlagEn from '@/assets/icons/flag-us.svg?react';

export type LanguageCode = 'uz' | 'ru' | 'en';

export interface AppLanguage {
  code: LanguageCode;
  name: string;
  Flag: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const APP_LANGUAGES: AppLanguage[] = [
  { code: 'uz', name: "O'zbekcha", Flag: FlagUz },
  { code: 'ru', name: 'Русский', Flag: FlagRu },
  { code: 'en', name: 'English', Flag: FlagEn },
];

export const LANGUAGE_CODES: LanguageCode[] = APP_LANGUAGES.map((lang) => lang.code);

export const DEFAULT_LANGUAGE: LanguageCode = 'uz';
export const REQUIRED_LANGUAGE: LanguageCode[] = ['uz', 'ru'];

export const getLanguageByCode = (code: string): AppLanguage | undefined => {
  return APP_LANGUAGES.find((lang) => lang.code === code);
};
